import { css } from '@emotion/css';

export const filterPaperStyles = css`
  width: 30rem;
`;

export const filterBottomSheetStyles = css`
  .MuiDrawer-paper {
    background-color: var(--bg-primary);
    border-top-left-radius: 1.2rem;
    border-top-right-radius: 1.2rem;
  }
`;
